import { render, staticRenderFns } from "./default.vue?vue&type=template&id=e8a087c6&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/private/var/folders/c0/mk3zh23n40nd2cwxybf80c0h0000gn/T/ltng/components/Header.vue').default,Footer: require('/private/var/folders/c0/mk3zh23n40nd2cwxybf80c0h0000gn/T/ltng/components/Footer.vue').default})
